import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import HeaderTopic from './../../partials/HeaderTopic';
import BasicButtons from './../../partials/BasicButtons';
import FooterMenu from '../../partials/FooterMenu';
import ShowSinglePlayerRow from './ShowSinglePlayerRow';
import PrimaryButton from './../../partials/PrimaryButton';
import styles from './GroupInfo.module.css';
import { getGroupsList } from '../../api/getGroupsList';
import { getGroupPlayers } from '../../api/getGroupPlayers';
import { playerAskJoinTeam } from '../../api/playerAskJoinTeam';
import * as func from '../../utils/funcs';

import editIcon from './../../graphics/icons/edit.svg';
import { getUserPlayerInfo } from '../../api/getUserPlayerInfo';
import { getLeagueInfo } from '../../api/getLeagueInfo';


function GroupInfo({
                     user,
                     setUser,
                     league,
                     setLeague,
                     teams,
                     setTeams,
                     players,
                     setPlayers,
                     invited,
                     setInvited,
                     refreshStates,
                   }) {
  const { leagueId, teamId } = useParams();
  const history = useHistory();
  const isReferee = user?.refereed_league_ids?.length > 0;
  const isRakaz = user.is_leagues_manager
  let customStatus = null;
  if (isReferee) {
    customStatus = 'referee';
  } else if (isRakaz) {
    customStatus = 'rakaz';
  }

  const [playerStatus, setPlayerStatus] = React.useState(
    customStatus ? customStatus : user.player.status
  );
  
  const [isJoining, setIsJoining] = React.useState(false);

  React.useEffect(() => {
    if (teams.length === 0 && invited !== null) {
      getGroupsList(leagueId).then(data => {
        setTeams(data);
      });
    }
  }, [invited, teams, leagueId, setTeams]);

  React.useEffect(() => {
    if (teams.length === 0 && invited !== null) {
      getLeagueInfo(leagueId).then(data => {
        setLeague(data);
      });
    }
  }, [invited, setLeague, teams, leagueId]);

  const group =
    teams.length > 0
      ? teams.filter(team => team.id === parseInt(teamId, 10))[0]
      : {
          slogan: 'טוען',
          name: 'טוען',
          image: 'none',
        };

  const shareGroupLink = `whatsapp://send?text=הצטרף לקבוצה שלי בליגת החלוץ >>> ${window.location.origin}/leagues/${leagueId}/teams/${teamId}/invite`;

  React.useEffect(() => {
    let mounted = true;

    getGroupPlayers(leagueId, teamId).then(data => {
      if (data.error) {
        // TODO: add connection Error
      } else {
        mounted && setPlayers(data);
      }
    });

    return function cleanup() {
      mounted = false;
    };
  }, [leagueId, teamId, history, setPlayers]);

  const handleClickJoin = async () => {
    setIsJoining(true);
    try {
      const newPlayer = await playerAskJoinTeam(leagueId, teamId);
      setPlayerStatus(newPlayer.status);
      setPlayers(p => [...p, newPlayer]);
      setUser(await getUserPlayerInfo());
      
      // Clear invited state after successful join
      if (setInvited) {
        setInvited(null);
      }
    } catch (error) {
      console.error('Error joining team:', error);
    } finally {
      setIsJoining(false);
    }
  };

  const handleClickToEdit = () => {
    history.push(`/leagues/${leagueId}/teams/${teamId}/edit`);
  };

  return (
    <div className={styles.showGroupInfo}>
      <HeaderTopic topic={league ? `ליגת ${league.name}` : 'ליגות החלוץ'} />
      <BasicButtons user={user} refreshStates={refreshStates} />
      <FooterMenu setActive="league" />

      <div className={styles.headerImg}>
        <img
          className={styles.teamImg}
          src={
            group.image !== 'none' && group.image !== null
              ? group.image
              : 'https://images.unsplash.com/photo-1527871252447-4ce32da643c6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2389&q=80'
          }
          /* src="https://wallpaperaccess.com/full/1249002.jpg" */
          alt="תמונת הקבוצה"
        />
        <img
          className={styles.edit}
          src={editIcon}
          alt="עריכת קבוצה"
          onClick={handleClickToEdit}
          style={
            func.validGroupMasters(user, teamId)
              ? { display: 'block' }
              : { display: 'none' }
          }
        />
      </div>
      <div className={styles.main}>
        <div className={styles.headerTopics}>
          <div className={styles.titles}>
            <h2>{group.name}</h2>
            <h4>{group.slogan}</h4>
          </div>
          {leagueId &&
            teamId &&
            playerStatus &&
            func.validSeeGroupCTAbtn(user, teamId) && (
              <div className={styles.ctaBtns}>
                {func.isPlayerStatus('no_team', user) ? (
                  <PrimaryButton
                    text="הצטרף לקבוצה"
                    onClick={handleClickJoin}
                    loading={isJoining}
                    disabled={isJoining}
                    size="medium"
                  />
                ) : func.isPlayerStatus('awaiting_confirmation', user) ? (
                  <PrimaryButton
                    text="מחכה לאישור"
                    disabled={true}
                    size="medium"
                  />
                ) : (
                  <a href={shareGroupLink} data-action="share/whatsapp/share">
                    <PrimaryButton
                      text="הזמן שחקן"
                      size="medium"
                    />
                  </a>
                )}
              </div>
            )}
        </div>

        <div className={styles.playersList}>
          {players.map(player => (
            <ShowSinglePlayerRow
              key={player.user_id}
              playerObj={player}
              user={user}
              setPlayers={setPlayers}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

/* GroupInfo.propTypes = {}; */

export default GroupInfo;
